import { openDB } from "idb";
/**
 * Class representing an IndexedDb.
 */
export class IndexedDb {
    constructor(database, initTable) {
        this.database = database;
        this.initDatabase(initTable).then();
    }
    async createObjectStore(tableNames) {
        try {
            const toCreate = [];
            if (!this.db) {
                this.db = await openDB(this.database);
            }
            for (const tableName of tableNames) {
                if (!this.db.objectStoreNames.contains(tableName)) {
                    toCreate.push(tableName);
                }
            }
            if (toCreate.length) {
                this.db?.close();
                const newVersion = this.db?.version + 1;
                this.db = await openDB(this.database, newVersion, {
                    upgrade(db) {
                        toCreate.forEach((tableName) => {
                            db.createObjectStore(tableName, { keyPath: "id" });
                        });
                    },
                });
            }
        }
        catch (error) {
            // console.log("indexedDB createObjectStore", error);
            return false;
        }
    }
    async getValue(tableName, id) {
        if (this.db) {
            const tx = this.db.transaction(tableName, "readonly");
            const store = tx.objectStore(tableName);
            return await store.get(id);
        }
        else {
            return null;
        }
    }
    async getAllValue(tableName) {
        if (this.db) {
            const tx = this.db.transaction(tableName, "readonly");
            const store = tx.objectStore(tableName);
            return await store.getAll();
        }
        else {
            return null;
        }
    }
    async putValue(tableName, value) {
        if (this.db) {
            const tx = this.db.transaction(tableName, "readwrite");
            const store = tx.objectStore(tableName);
            return await store.put(value);
        }
        else {
            return null;
        }
    }
    async putBulkValue(tableName, values) {
        if (this.db) {
            const tx = this.db.transaction(tableName, "readwrite");
            const store = tx.objectStore(tableName);
            for (const value of values) {
                await store.put(value);
            }
            return this.getAllValue(tableName);
        }
        else {
            return null;
        }
    }
    async deleteValue(tableName, id) {
        if (this.db) {
            const tx = this.db.transaction(tableName, "readwrite");
            const store = tx.objectStore(tableName);
            const result = await store.get(id);
            if (!result) {
                return result;
            }
            await store.delete(id);
            return id;
        }
        else {
            return null;
        }
    }
    async initDatabase(initTable) {
        try {
            this.db = await openDB(this.database, undefined, {
                upgrade: (db) => {
                    initTable && db.createObjectStore(initTable, { keyPath: "id" });
                },
            });
        }
        catch (error) {
            localStorage.setItem("IndexedDBErrors", String(error));
            // console.error("Error initializing IndexedDB:", error);
        }
    }
}
